import { AppMarketingLabel } from '@atlassian/mpac-types';
export const makeCategoryLozenges = _ref => {
  let {
    categories
  } = _ref;
  if (categories.some(category => category.name === 'Mobile')) {
    return [{
      label: 'Supports Mobile',
      tooltipContent: undefined
    }];
  }
  return [];
};
export const makeProductCompatibilityLozenges = _ref2 => {
  let {
    marketingLabels,
    showNewJiraSoftwareLabelFlag
  } = _ref2;
  const lozenges = [];
  if (marketingLabels.includes(AppMarketingLabel.CompatibleWithJSM)) {
    const flavor = 'Jira Service Management';
    lozenges.push({
      label: flavor,
      tooltipContent: undefined
    });
  }
  if (marketingLabels.includes(AppMarketingLabel.CompatibleWithJSW)) {
    const flavor = showNewJiraSoftwareLabelFlag ? 'Jira' : 'Jira Software';
    lozenges.push({
      label: flavor,
      tooltipContent: undefined
    });
  }
  return lozenges;
};
export const makeSupportInfoLozenges = _ref3 => {
  let {
    supportDetails,
    partnerName,
    isServerAppEos
  } = _ref3;
  const {
    issueTrackerUrl,
    supportTicketSystemUrl,
    emailId
  } = (supportDetails === null || supportDetails === void 0 ? void 0 : supportDetails.contact) || {};
  const hasOfficialSupport = supportDetails.isSupported && (issueTrackerUrl || supportTicketSystemUrl || emailId);
  if (isServerAppEos) return [];else if (hasOfficialSupport) {
    if (!partnerName) return [];
    return [{
      label: 'Partner Supported',
      appearance: 'success',
      tooltipContent: undefined
    }];
  } else return [{
    label: 'Unsupported',
    tooltipContent: undefined
  }];
};
export const makeCloudMigrationLozenge = _ref4 => {
  let {
    cloudMigration = {},
    showCloudMigrationLozenge
  } = _ref4;
  if (!showCloudMigrationLozenge) return [];
  const {
    featureDifferenceDocumentation,
    migrationDocumentation
  } = cloudMigration || {};
  const hasDocumentation = featureDifferenceDocumentation || migrationDocumentation;
  if (!hasDocumentation) {
    return [];
  }
  return [{
    label: 'Cloud Migration Assistance',
    appearance: 'inprogress',
    tooltipContent: undefined
  }];
};
export const makeHeaderLozenges = _ref5 => {
  let {
    supportDetails,
    partnerName,
    supportLink,
    cloudMigration,
    onMigrationLozengeClick,
    showCloudMigrationLozenge,
    isServerAppEos
  } = _ref5;
  return [...makeSupportInfoLozenges({
    supportDetails,
    partnerName,
    supportLink,
    isServerAppEos
  }), ...makeCloudMigrationLozenge({
    cloudMigration,
    onMigrationLozengeClick,
    showCloudMigrationLozenge
  })].filter(Boolean);
};